module.exports = __webpack_public_path__ + "img/38.a1527ac9.svg";